import React from 'react'
import { View, useWindowDimensions } from 'react-native'
import { StyleSheet } from 'react-native'
import { COLORS } from '../../../../constants';
import { _scale } from '../../../../utils/appHelper';
import LoginComponent from '../../../components/loginComponent/index.web';
import { useNavigation } from '@react-navigation/native';


export default function Login() {
    const navigation= useNavigation()
    const dimensions = useWindowDimensions();
    const isLargeScreen = dimensions.width >= 768;

    return (
        <View style={commonStyles.mainContainer} key={'MainContainer'}>
            <View style={commonStyles.webSubContainerStyle} key={'SubContainer'}>
                <View style={[commonStyles.webBorderViewStyle, { width: isLargeScreen ? '40%' : '90%' }]} key={'BorderView'}>
                    <View style={{ flex: 1}}>
                        <LoginComponent navigation={navigation} />
                    </View>
                </View>
            </View>

        </View>
    )
}



const commonStyles = StyleSheet.create({
    mainContainer: {
        flex: 1,
        backgroundColor: COLORS.appColor
    },
    webSubContainerStyle: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
     
    },
    webBorderViewStyle: {
        width: '50%',
        height: '80%',
        flex:1
    },
})




